module.exports = "<app-dashboard></app-dashboard>\r\n"